export enum ConfirmationDialogResponse {
    DELETE = 'delete',
    REMOVE = 'remove',
    CONTINUE = 'continue',
    COMPLETE = 'complete',
    CANCEL = 'cancel',
    YES = 'yes',
    NO = 'no',
    SUPPRESS = 'suppress',
    UNSUPPRESS = 'unsuppress',
    CLOSE = 'close',
    SUBMIT = 'submit',
}